import { MemCommonEditorStore } from "@/components/note/store/mem-common-editor-store";
import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { AudioCaptureActions } from "@/components/note/floating-actions/audio-capture";
import { CleanUpActions } from "@/components/note/floating-actions/clean-up-actions";

interface VoiceActionsProps {
  editorStore: MemCommonEditorStore;
  onRequestClose?: () => void;
}

export const VoiceActions = observer<VoiceActionsProps>(function VoiceActions({
  editorStore,
  onRequestClose,
}) {
  const { store } = useAppStore();

  const noteId = editorStore.noteObservable?.id;
  const noteRecording = noteId ? store.audioRecordings.getNoteRecording({ noteId }) : undefined;
  const recording = noteRecording?.recording;
  const isActiveForNote = noteId ? store.audio.activeRecordingNoteId === noteId : false;

  const isSuggestionActive = Boolean(editorStore.noteObservable?.isSuggestionActive);
  const shouldShowAudioActions = Boolean(
    noteId &&
      ((recording && !recording.isTrashed && recording.hasNotBeenCompleted) || isActiveForNote)
  );

  /**
   * If we have an active "suggestion" (e.g. a voice recording suggestion), we
   * prioritize showing that.
   */
  if (isSuggestionActive) {
    return <CleanUpActions editorStore={editorStore} />;
  }

  /**
   * Otherwise; If we have an active audio recording, show the audio actions.
   */
  if (shouldShowAudioActions && noteId) {
    return <AudioCaptureActions noteId={noteId} onRequestClose={onRequestClose} />;
  }

  /**
   * Otherwise, don't show any actions.
   */
  return null;
});
